var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170.08 170.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: .5px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #1f140f;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-4, .cls-6 {\n        fill: #1f140f;\n      }\n\n      .cls-4 {\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.59,
    y: 91.63,
    width: 18.9,
    height: 16.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.25,76.04v59.79c0,.73.06,1.45.19,2.15.63,3.67,3.87,6.44,7.58,6.45h87.64c6.85,0,12.41-5.55,12.41-12.4v-55.99H31.25ZM67.35,91.32h-.01v18.38h-24.15v-21.48h24.17v3.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.51,144.14c.06.08.11.17.18.24h.01c-.07-.08-.12-.15-.19-.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.06,40.78v20.28H31.25v-16.46c0-6.84,5.56-12.41,12.41-12.41h87.57c1.87,0,3.75.43,5.4,1.25,1.59,2.14,2.44,4.67,2.44,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.98,30.43v.25h3.78v-.25h-3.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.73,32.01c-1.98-1.04-4.23-1.59-6.5-1.59H50.76v.25h-3.78v-.25h-3.33c-7.8,0-14.16,6.36-14.16,14.16v18.17s-.01.03,0,.04c.12,1,.98,1.79,2.02,1.79h113.88v-20c0-5.32-2.93-10.13-7.66-12.57ZM139.06,61.05H31.25v-16.46c0-6.84,5.56-12.41,12.41-12.41h87.57c1.87,0,3.75.43,5.4,1.25,1.59,2.14,2.44,4.67,2.44,7.35v20.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.59,
    y: 91.63,
    width: 18.9,
    height: 16.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.25,76.04v59.79c0,.73.06,1.45.19,2.15.63,3.67,3.87,6.44,7.58,6.45h87.64c6.85,0,12.41-5.55,12.41-12.4v-55.99H31.25ZM67.35,91.32h-.01v18.38h-24.15v-21.48h24.17v3.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.51,144.14c.06.08.11.17.18.24h.01c-.07-.08-.12-.15-.19-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.5,74.3v61.53c0,3.18,1.04,6.19,3,8.69,2.7,3.48,6.78,5.47,11.16,5.47h87.57c7.81,0,14.16-6.35,14.16-14.16v-61.53H29.5ZM32.68,144.38c-.07-.08-.12-.17-.18-.24.07.09.12.17.19.24h-.01ZM139.06,132.03c0,6.84-5.55,12.4-12.41,12.4H39.02c-3.71-.01-6.95-2.78-7.58-6.45-.13-.69-.19-1.42-.19-2.15v-59.79h107.82v55.99Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.5,62.55v.21c-.02-.07-.02-.13-.02-.21h.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 46.59,
    y: 91.63,
    width: 18.9,
    height: 16.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.18,88.22v21.48h24.15v-18.38h.01v-3.1h-24.17ZM46.59,91.63h18.9v16.22h-18.9v-16.22Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.25,60.98h107.82v-16.25c0-6.93-5.62-12.55-12.55-12.55H43.79c-6.93,0-12.55,5.62-12.55,12.55v16.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/Agenda.df9775169e650e4c0e191fdb8333faf5.svg";
export { ForwardRef as ReactComponent };